<template>
  <nav>
    <div class='has-tooltip my-8 w-8'>
      <span class='tooltip'> Home</span>
      <router-link :to="dashboardPath">
        <home-icon
        :class="$route.fullPath === dashboardPath ?
        'text-orange-academy-300' : 'hover:text-orange-academy-300'" />
      </router-link>
    </div>
    <div class='has-tooltip my-8 w-8'>
      <span class='tooltip'> {{$t('lesson.classrooms')}}</span>
      <router-link :to="dashboardPath+'/classrooms'">
        <classroom-icon
        :class="$route.fullPath === dashboardPath+'/classrooms' ?
        'text-orange-academy-300' : 'hover:text-orange-academy-300'" />
      </router-link>
    </div>
    <div class='has-tooltip my-8 w-8'>
      <span class='tooltip'> Masterclasses</span>
      <router-link :to="dashboardPath+'/masterclasses'">
        <masterclass-icon
        :class="$route.fullPath === dashboardPath+'/masterclasses' ?
        'text-orange-academy-300' : 'hover:text-orange-academy-300'" />
      </router-link>
    </div>
    <div class='has-tooltip my-8 w-8' v-if="isTeacher">
      <span class='tooltip'> {{ $t('teacher.payments') }}</span>
      <router-link :to="dashboardPath+'/payments'" class="my-8 w-6 lg:w-8" >
        <payments-icon
        :class="$route.fullPath === dashboardPath+'/payments' ?
        'text-beige-academy-300' : 'hover:text-beige-academy-300'" />
      </router-link>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';
import HomeIcon from './HomeIcon.vue';
import ClassroomIcon from './ClassroomIcon.vue';
import PaymentsIcon from './PaymentsIcon.vue';
import MasterclassIcon from './MasterclassIcon.vue';

export default {
  props: ['profilePic'],

  components: {
    HomeIcon,
    ClassroomIcon,
    MasterclassIcon,
    PaymentsIcon,
  },

  computed: {
    ...mapGetters({
      isTeacher: 'auth/isTeacher',
      dashboardPath: 'auth/dashboardPath',
    }),
  },

};
</script>

<style scoped lang="scss">
  .tooltip {
    @apply invisible absolute text-gray-500 text-xs mt-10 font-sans-serif;
  }

  .has-tooltip:hover .tooltip {
    @apply visible z-50;
  }
</style>
